<script>
    import axios from "axios";
    export default {
        methods: {
            isset(property) {
                if (typeof(property) != "undefined" && property !== null) {
                    return true;
                }
            },
            uniqid() {
                return (Math.round(
                        Number(Date.now()) * Math.random() * 100 / (Math.random() * 10)
                    )
                );
            },
            getCookie(name, handler) { // Not work i JS becouse need wait
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/get_cookie",
                    data: {
                        name: name
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    handler(response);
                })
                .catch(error => {
                    return 'error';
                });
            },
            setCookie(name, value, days) {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/set_cookie",
                    data: {
                        name: name,
                        value: value
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    return 'error';
                });
            },
            unsetCookie(name) {
                axios({
                    method: "post",
                    url: window.globalVariables.locale + "/forget_cookie",
                    data: {
                        name: name
                    },
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                })
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    return 'error';
                });
            },
            jsonParse(string) {
                // TODO check why error with replace a-z0-9
                return JSON.parse(string.replace(/\n/g, "\\n"));
                // return JSON.parse(string.replace(/\n/g, "\\n").replace(/[^a-zA-Z0-9]/g, ''));
            },
            removeSpecialChars(str) {
                return str.replace(/(?!\w|\s)./g, '')
                .replace(/\s+/g, ' ')
                .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, '$2');
            }
        }
    }
</script>